import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { IftaLabelModule } from 'primeng/iftalabel';
import { MultiSelectModule } from 'primeng/multiselect';
import { ToggleSwitchModule } from 'primeng/toggleswitch';

@Component({
    selector: 'app-custom-export-dialog',
    templateUrl: './custom-export-dialog.component.html',
    styleUrls: [ './custom-export-dialog.component.scss' ],
    imports: [
        FormsModule,
        DialogModule,
        ButtonModule,
        MultiSelectModule,
        IftaLabelModule,
        ToggleSwitchModule,
    ]
})
export class CustomExportDialogComponent implements OnInit {
    @Input() visible = false;

    @Input() fieldOfUseOptions: any[] = [];
    @Input() sampleTypeOptions: any[] = [];
    @Input() sampleStateOptions: any[] = [];
    @Input() sampleCategoryOptions: any[] = [];
    @Input() sampleDetailOptions: any[] = [];
    @Input() sampleFormatOptions: any[] = [];

    @Input() brandOptions: any[] = [];
    @Input() carClassOptions: any[] = [];
    @Input() bodyTypeOptions: any[] = [];

    @Input() initialFilters: {
        fieldOfUse?: string[],
        sampleType?: number[],
        sampleState?: string[],
        sampleCategory?: number[],
        sampleDetail?: number[],
        format?: string[],
        brand?: number[],
        carClass?: number[],
        bodyType?: number[],
    } = {};

    @Input() initialHideEmptyColumns = true;

    @Output() visibleChange = new EventEmitter<boolean>();
    @Output() exportConfirmed = new EventEmitter<{
        filters: {
            fieldOfUse?: string[],
            sampleType?: number[],
            sampleState?: string[],
            sampleCategory?: number[],
            sampleDetail?: number[],
            format?: string[],
            brand?: number[],
            carClass?: number[],
            bodyType?: number[],
        },
        hideEmptyColumns: boolean
    }>();

    filters: {
        fieldOfUse?: string[],
        sampleType?: number[],
        sampleState?: string[],
        sampleCategory?: number[],
        sampleDetail?: number[],
        format?: string[],
        brand?: number[],
        carClass?: number[],
        bodyType?: number[],
    } = {};

    hideEmptyColumns = true;

    ngOnInit() {
        this.filters = { ...this.initialFilters };
        this.hideEmptyColumns = this.initialHideEmptyColumns;
    }

    close(): void {
        this.visible = false;
        this.visibleChange.emit(false);
    }

    reset(): void {
        this.filters = {};
        this.hideEmptyColumns = true;
    }

    confirm(): void {
        this.exportConfirmed.emit({
            filters: this.filters,
            hideEmptyColumns: this.hideEmptyColumns,
        });
        this.close();
    }

    getActiveFiltersSummary(): string {
        const filterLabels: { [key: string]: string } = {
            fieldOfUse: 'Field of Use',
            sampleType: 'Sample Type',
            sampleState: 'State',
            sampleCategory: 'Category',
            sampleDetail: 'Details',
            format: 'Format',
            brand: 'Brand',
            carClass: 'Car Class',
            bodyType: 'Body Type'
        };

        const optionMaps: { [key: string]: any[] } = {
            fieldOfUse: this.fieldOfUseOptions,
            sampleType: this.sampleTypeOptions,
            sampleState: this.sampleStateOptions,
            sampleCategory: this.sampleCategoryOptions,
            sampleDetail: this.sampleDetailOptions,
            format: this.sampleFormatOptions,
            brand: this.brandOptions,
            carClass: this.carClassOptions,
            bodyType: this.bodyTypeOptions
        };

        return Object.entries(this.filters)
            .filter(([ _, value ]) => value && value.length > 0)
            .map(([ key, value ]) => {
                const label = filterLabels[key] || key;
                const options = optionMaps[key] || [];
                const selectedLabels = value
                    .map((val: any) => {
                        const found = options.find(opt => opt.value === val || opt.id === val);
                        return found?.label || found?.name || val;
                    })
                    .join(', ');
                return `${ label }: "${ selectedLabels }"`;
            })
            .join('; ');
    }

}
